import { maritalStatusThatAllowsMaritalRegime } from "../../../components/modules/kyc/shared/config";

export const FamiliarSituationDetailsMapper = {
  reverseMap(data) {
    return {
      marital_status: data.maritalStatus,
      ...(data.maritalStatus === maritalStatusThatAllowsMaritalRegime
        ? { marital_regime: data.maritalRegime }
        : {}),
      child_support_number: parseInt(data.childSupportNumber, 10),
    };
  },
};
